import { alpha, styled } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiAutocomplete-inputRoot": {
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    borderRadius: "1.7rem",
    transition: "all 0.2s ease-in-out",
    border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,

    "&:hover": {
      backgroundColor: theme.palette.background.paper,
      borderColor: alpha(theme.palette.primary.main, 0.3),
    },

    "&.Mui-focused": {
      boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.25)}`,
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.background.paper,
    },
  },

  "& .MuiAutocomplete-clearIndicator": {
    color: alpha(theme.palette.text.secondary, 0.7),
    transition: "all 0.2s ease",
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.divider, 0.1),
      borderRadius: "50%",
    },
  },

  "& .MuiAutocomplete-popupIndicator": {
    color: alpha(theme.palette.text.secondary, 0.7),
    transition: "all 0.2s ease",
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.divider, 0.1),
      borderRadius: "50%",
    },
    "&.MuiAutocomplete-popupIndicatorOpen": {
      transform: "rotate(180deg)",
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

export const AutocompleteStyledPopper = styled(Popper)(({ theme }) => ({
  zIndex: 9999,
  "& .MuiAutocomplete-listbox": {
    padding: "6px 0",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: alpha(theme.palette.divider, 0.7),
      borderRadius: 15,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: alpha(theme.palette.divider, 0.1),
      borderRadius: 15,
    },
  },
}));

export const AutocompleteStyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: theme.shadows[4],
  border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
  marginTop: "4px",
  backdropFilter: "blur(8px)",

  "& .MuiAutocomplete-option": {
    padding: "10px 16px",
    transition: "all 0.15s ease",
    minHeight: "44px",
    display: "flex",
    alignItems: "center",
    borderRadius: 8,
    margin: "2px 6px",

    '&[data-focus="true"]': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      color: theme.palette.primary.main,
    },

    '&[aria-selected="true"]': {
      backgroundColor: alpha(theme.palette.primary.main, 0.15),
      color: theme.palette.primary.dark,
      fontWeight: 500,

      '&[data-focus="true"]': {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
      },
    },

    "&:hover": {
      backgroundColor: alpha(theme.palette.action.hover, 0.1),
    },
  },

  "& .MuiAutocomplete-noOptions": {
    padding: "10px 16px",
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
  },

  "& .MuiAutocomplete-loading": {
    padding: "10px 16px",
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
  },

  "& .MuiAutocomplete-groupLabel": {
    padding: "8px 16px",
    fontSize: "0.75rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: theme.palette.text.secondary,
    backgroundColor: alpha(theme.palette.background.paper, 0.9),
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
}));
